(() => {
  const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (motionPreference.matches || !('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting, intersectionRatio }) => {
      if (!isIntersecting || intersectionRatio < .25) return;
      target.classList.add('is-revealed');
      observer.unobserve(target);
    });
  }, { threshold: .25 });

  const initialize = (root) => {
    root.querySelectorAll('[data-curls-award-reveal]:not(.is-reveal-pending)').forEach((logo) => {
      logo.classList.add('is-reveal-pending');
      observer.observe(logo);
    });
  };

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  motionPreference.addEventListener('change', ({ matches }) => {
    if (!matches) return;
    observer.disconnect();
    document.querySelectorAll('[data-curls-award-reveal]').forEach((logo) => logo.classList.add('is-revealed'));
  });
})();
